import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import IntlHelper from 'utils/helpers/intl.helper';
import { useSelector, useDispatch } from 'react-redux';

import services from 'services';
import utils from 'utils';
import selector from 'state/selectors';
import action from 'state/actions';

import { modalActionType, notDraggable } from 'utils/constants';
import { TextInput } from 'components/Input';

import Modal from './';

const ResetPassword = () => {
  const t = IntlHelper.useTranslator();
  const dispatch = useDispatch();
  const [mail, setMail] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<'initial' | 'nomail' | 'wrongmail' | ''>('initial');

  const activeModalType = useSelector(selector.modal.getActionType);
  const modalVisibility = useSelector(selector.modal.getVisibility);
  const closeModal = () => dispatch(action.modal.closeModal());
  const isModalDraggable = notDraggable.includes(activeModalType || '');

  const errorMessageHandler = (value: string) => {
    if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      setErrorMessage('wrongmail');
    } else if (value === '') {
      setErrorMessage('initial');
    } else {
      setErrorMessage('');
    }
  };

  useDebounce(
    () => {
      errorMessageHandler(mail);
    },
    700,
    [mail],
  );

  const resetEmailHandler = async () => {
    try {
      const { data } = await services.resetPassword(mail);
      utils.app.notify('success', data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const input = document.querySelector('input[name="mail"]');
    if (input && document.activeElement !== input) {
      (input as HTMLInputElement).focus();
    }
  }, [mail]);

  useLayoutEffect(() => {
    const input = document.querySelector('input[name="mail"]') as HTMLInputElement | null;
    if (input) {
      const pos = input.value.length;
      input.focus();
      input.setSelectionRange(pos, pos);
    }
  }, [errorMessage]);

  return modalVisibility && activeModalType && activeModalType === modalActionType.RESET_PASSWORD ? (
    <Modal open={modalVisibility} onClose={closeModal} style={{ width: '400px' }} isDraggable={!isModalDraggable}>
      <>
        <Modal.Header title={t('reset_password')} />
        <div>
          <TextInput
            id="reset-password-mail"
            fullWidth
            name="mail"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setMail(e.target.value);
            }}
            onBlur={() => !mail && setErrorMessage('nomail')}
            placeholder={t('mail')}
            value={mail}
            hasFeedback={errorMessage === 'nomail' || errorMessage === 'wrongmail'}
            feedbackMessage={t(errorMessage)}
          />
        </div>
        <Modal.Footer
          confirmText={t('continua')}
          confirmAction={resetEmailHandler}
          confirmDisabled={Boolean(errorMessage) || !mail}
          withCloseButton
        />
      </>
    </Modal>
  ) : null;
};

export default ResetPassword;
